const paymentSetData = data => ({
  type: 'PAYMENT_SET_DATA', payload: data,
})

export { paymentSetData }
